import { Model } from '../services';

/**
 * Informa se o prescritor pode editar ou excluir o modelo.
 *
 * O modelo pessoal é sempre gerenciável pelo dono, já que a listagem só entrega
 * os dele. O institucional exige ser administrador de modelos institucionais do
 * parceiro. O patrocinado nunca é gerenciável pelo prescritor.
 *
 * @param model Modelo exibido na lista.
 * @param isInstitutionalModelAdmin Se o prescritor administra modelos institucionais do parceiro.
 * @returns Verdadeiro quando as ações de editar e excluir devem aparecer.
 */
export function canManageModel(model: Model, isInstitutionalModelAdmin: boolean): boolean {
  if (model.sponsored) return false;

  if (model.origin === 'institutional') return isInstitutionalModelAdmin;

  return model.origin === 'personal';
}
